const ADD_TO_REGISTRY = 'addToRegistry';
const GET_USER_REGISTRIES = 'getUserRegistries';

export {
  ADD_TO_REGISTRY,
  GET_USER_REGISTRIES,
};
